import React, { Component } from 'react';
import { Header, Container, Segment, List } from 'semantic-ui-react';
import ReactMarkdown from 'react-markdown';

const listFunction = list => (
  <List as="ol" size="large" className="kriterier">
    {list.children}
  </List>
);

class Reasons extends Component {
  render() {
    const {
      kriterierTittel,
      kriterierIntroduksjonstekst,
      kriterierOpplistning,
    } = this.props;
    return (
      <Container text id="kriterier">
        <Header as="h1">{kriterierTittel}</Header>
        <ReactMarkdown source={kriterierIntroduksjonstekst} />
        <Segment basic>
          <ReactMarkdown
            source={kriterierOpplistning}
            renderers={{ list: listFunction }}
          />
        </Segment>
      </Container>
    );
  }
}

export default Reasons;



// WEBPACK FOOTER //
// ./src/LandingPage/Criterion.js